module.exports = __webpack_public_path__ + "img/icon_deal.104ac82d.svg";